export default {
    data () {
        return {
            title: '商贷首付比例测试'
        }
    }
}